import { TabWrap } from 'sections/TabWrap';

import { useShippingAddress } from './ShippingAddress.hooks';

export function ShippingAddress(): React.ReactElement {
  const { sections } = useShippingAddress();

  return <TabWrap sections={sections} />;
}
